module.exports = __webpack_public_path__ + "static/media/environment.62d147d8.png";